//
// Module for the Employer Reporting Service Purchase Paid Off report criteria
//
rs.module("content/reports/criteria/employerreportingservicepurchasepaidoffcriteria",

    ["controls/data/grid"],

    function (gridModule) {

        //
        // Initialize the module
        //
        function initialize(lrsGridApi, jsSelectors, backendUrl) {
            var filter = $.js(jsSelectors.filter);
            var employerSelect = filter.js(jsSelectors.employerSelect);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            employerSelect.change(employerChanged);

            /**
             * Hookup Ajax to changed employer selection
             */
            function employerChanged() {
                loadingSpinner.show();
                gridModule.update(
                    backendUrl,

                    { employerKey: employerSelect.val() },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);